// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"cdbb5113f8ddf6ba","983":"4a8d4f6da50d3e72"}[chunkId] + ".js";
};